/** Impressão A4 / 80mm com CODE128 (JsBarcode via CDN na janela de impressão). */

export function abrirImpressaoPedidoComercial(imp, { modo = '80mm' } = {}) {
  if (!imp) return;
  const isA4 = modo === 'a4';
  const linhas = (imp.linhas80mm || []).map((l) => escapeHtml(l)).join('<br/>');
  const itensRows = (imp.itens || [])
    .map(
      (i) => `<tr>
        <td>${escapeHtml(i.produtoCodigo || '')}</td>
        <td>${escapeHtml(i.produtoDescricao || '')}</td>
        <td style="text-align:right">${fmt(i.quantidade)}</td>
        <td style="text-align:right">${fmt(i.valorUnitario)}</td>
        <td style="text-align:right">${fmt(i.valorTotal)}</td>
      </tr>`,
    )
    .join('');

  const html = `<!doctype html>
<html><head><meta charset="utf-8"/>
<title>${escapeHtml(imp.codigo || 'Documento')}</title>
<style>
  @page { size: ${isA4 ? 'A4' : '80mm auto'}; margin: ${isA4 ? '12mm' : '3mm'}; }
  body { font-family: ui-monospace, Consolas, monospace; font-size: ${isA4 ? '12px' : '11px'}; color: #111; }
  h1 { font-size: ${isA4 ? '18px' : '14px'}; margin: 0 0 8px; }
  .meta { margin-bottom: 8px; }
  table { width: 100%; border-collapse: collapse; margin-top: 8px; }
  th, td { border-bottom: 1px solid #ddd; padding: 3px 2px; vertical-align: top; }
  th { text-align: left; }
  .total { font-weight: 800; font-size: 14px; margin-top: 8px; }
  .barcode { text-align: center; margin: 10px 0; }
  .cupom { white-space: pre-wrap; }
  @media print { .noprint { display: none; } }
</style>
</head><body>
  <div class="noprint" style="margin-bottom:8px">
    <button onclick="window.print()">Imprimir</button>
  </div>
  <h1>${escapeHtml(imp.estabelecimentoNome || '')}</h1>
  <div class="meta">
    <strong>${escapeHtml(imp.tipo === 'Pedido' ? 'PEDIDO DE VENDA' : 'ORCAMENTO')}</strong><br/>
    Código: <strong>${escapeHtml(imp.codigo || '')}</strong><br/>
    Cliente: ${escapeHtml(imp.clienteNome || 'Consumidor')}<br/>
    ${imp.documento ? `Doc: ${escapeHtml(imp.documento)}<br/>` : ''}
    Data: ${fmtDate(imp.dataCriacao)}
  </div>
  <div class="barcode">
    <svg id="bc"></svg>
    <div>${escapeHtml(imp.codigo || '')}</div>
  </div>
  ${
    isA4
      ? `<table><thead><tr>
          <th>Cód</th><th>Descrição</th><th style="text-align:right">Qtd</th>
          <th style="text-align:right">Unit</th><th style="text-align:right">Total</th>
        </tr></thead><tbody>${itensRows}</tbody></table>
        <div class="total">TOTAL: R$ ${fmt(imp.valorTotal)}</div>`
      : `<div class="cupom">${linhas}</div>`
  }
  <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"><\/script>
  <script>
    try {
      JsBarcode('#bc', ${JSON.stringify(String(imp.codigo || ''))}, {
        format: 'CODE128', displayValue: false, height: 48, margin: 0, width: 1.6
      });
    } catch (e) {}
    setTimeout(function(){ window.print(); }, 250);
  <\/script>
</body></html>`;

  const w = window.open('', '_blank', 'noopener,noreferrer,width=480,height=720');
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
}

function fmt(v) {
  return Number(v || 0).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 3,
  });
}

function fmtDate(v) {
  if (!v) return '—';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('pt-BR');
}

function escapeHtml(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
